export default [
  {
    name: 'livelo-statement',
    path: '/livelo',
    component: () => import('@/views/LiveloStatement.vue'),
    props: true,
  },
  {
    name: 'livelo-landing-page',
    path: '/livelo/mais-informacoes',
    component: () => import('@/views/LiveloLandingPage.vue'),
    props: true,
  },
];
